/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarNoteDtoFromJSON, CarNoteDtoToJSON, } from './';
export function CarNoteSectionDtoFromJSON(json) {
    return CarNoteSectionDtoFromJSONTyped(json, false);
}
export function CarNoteSectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'notes': !exists(json, 'notes') ? undefined : (json['notes'] === null ? null : json['notes'].map(CarNoteDtoFromJSON)),
    };
}
export function CarNoteSectionDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carId': value.carId,
        'notes': value.notes === undefined ? undefined : (value.notes === null ? null : value.notes.map(CarNoteDtoToJSON)),
    };
}
